import { render } from "./AdminSidebar.vue?vue&type=template&id=6cdd850f&ts=true"
import script from "./AdminSidebar.vue?vue&type=script&lang=ts"
export * from "./AdminSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__